import { Button } from "@/components/ui/Button";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/Card";
import { useAuth } from "@/hooks/useAuth";
import { useUser } from "@/queries/user/useUser";
import { useNavigate } from "react-router";
import { useBuyPanelsStore } from "../buypanels/store";
import BackButton from "@/components/ui/BackButton";
type VerifiedProps = {
  onSuccess: () => void;
};

export default function Verified({ onSuccess }: VerifiedProps) {
  const { data: user, isPending } = useUser();
  const { handleSignOut } = useAuth();
  const navigate = useNavigate();
  const getPreviousStep = useBuyPanelsStore((state) => state.getPreviousStep);

  const handleBack = () => {
    const previousStep = getPreviousStep();
    navigate(previousStep);
  };

  return (
    <div className={"w-full max-w-lg mx-auto"}>
      <Card className="bg-brand-neutral-800 border-transparent shadow-none py-10">
        <CardHeader className="min-w-80">
          <CardTitle className="flex justify-between items-center">
            <span>Account Verified</span>{" "}
            <Button
              variant="ghost"
              onClick={handleSignOut}
              className="hover:underline hover:bg-transparent"
            >
              Sign out
            </Button>
          </CardTitle>
          <CardDescription>Please continue with your order.</CardDescription>
        </CardHeader>
        <CardContent className="min-w-80">
          <div className="flex gap-3">
            <BackButton handleBack={handleBack} className="flex-1" buttonClassName="w-full justify-start" />
            <Button
              className="flex-1"
              onClick={onSuccess}
              disabled={!user || isPending}
            >
              Proceed
            </Button>
          </div>
        </CardContent>
      </Card>
      <div></div>
    </div>
  );
}
